import React, { useState, useEffect, useRef  } from 'react'
import {
    Card,
    Checkbox,
    FormControlLabel,
    Grid,
    Button,
    CircularProgress,
    Dialog,
    DialogContent,
    DialogTitle
} from '@material-ui/core'
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';

import { LoonsSnackbar } from 'app/components/LoonsLabComponents'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import useAuth from 'app/hooks/useAuth'
import history from 'history.js'

import UserServices from 'app/services/UserServices'
import { IconButton, InputAdornment } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Typography, Box, AppBar, Toolbar } from "@mui/material";
import { Autocomplete } from '@material-ui/lab';
import * as appConst from '../../../../appconst';

import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CloseIcon from "@mui/icons-material/Close";

const steps = ['Step 1', 'Step 2', 'Step 3'];


const useStyles = makeStyles(({ palette, ...theme }) => ({
    cardHolder: {
        background: '#1A2038',
    },
    card: {
        maxWidth: 750,
        borderRadius: 12,
        margin: '1rem',
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    socialButton: {
        width: '100%',
        '& img': {
            margin: '0 8px',
        },
    },
    labelLink: {
        color: palette.primary.main,
        textDecoration: 'underline',
    },
    responsiveCard: {
        backgroundColor: "#FFFFFFD4",
        borderRadius: 15,
        paddingTop: 10,
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        marginLeft: 'auto',
        marginRight: 'auto',
        [theme.breakpoints.down('sm')]: {
            width: '90%',
        },
        [theme.breakpoints.between('sm', 'md')]: {
            width: '80%',
        },
        [theme.breakpoints.up('md')]: {
            width: 650,
        },
        [theme.breakpoints.up('lg')]: {
            width: 750,
        },
    },

    fields: {
    '& .MuiInputBase-root': {
        height: 40,
    },
    '& .MuiOutlinedInput-input': {
        padding: '8px 14px', // Adjust to vertically center text
        height: '100%',
        boxSizing: 'border-box',
    }
}


    // responsiveContainer: {
    //     paddingLeft: theme.spacing(3),
    //     paddingRight: theme.spacing(3),
    //     marginLeft: 'auto',
    //     marginRight: 'auto',
    //     [theme.breakpoints.down('sm')]: {
    //         width: '95%',
    //     },
    //     [theme.breakpoints.between('sm', 'md')]: {
    //         width: '90%',
    //     },
    //     [theme.breakpoints.up('md')]: {
    //         width: 650,
    //     },
    //     [theme.breakpoints.up('lg')]: {
    //         width: 750,
    //     },
    // },
}))

const FirebaseRegister = () => {
    const [loading, setLoading] = useState(false)
    const [contact_no_1, seContact1] = useState(null)
    const [contact_no_2, seContact2] = useState(null)

    const classes = useStyles()
    const [alert, setAlert] = useState(false)
    const [severity, setSeverity] = useState('')
    const [message, setMessage] = useState('')
    const [stepperOn, setStepperOn] = useState(false)
    const [open, setOpen] = useState(false)
    const { createUserWithEmailAndPassword, signInWithGoogle } = useAuth()

    const [showPassword, setShowPassword] = useState(false);

    const [activeStep, setActiveStep] = React.useState(0);
    const [skipped, setSkipped] = React.useState(new Set());
    const [stripeData, setStripeData] = useState({})
    const [stripeOpen, setStripeOpen] = useState(false)

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        username: '',
        contact_no: '',
        email: '',
        password: '',
        password_conforation:'',
        type: "Customer"
    })

    const formRef = useRef();


    useEffect(() => {
        ValidatorForm.addValidationRule('isPasswordMatch', (value) => {
          if (value !== formData.password) {
            return false;
          }
          return true;
        });
      
        // Optional: clean up the rule when component unmounts
        return () => ValidatorForm.removeValidationRule('isPasswordMatch');
      }, [formData.password]);

     const handleChange = ({ target: { name, value } }) => {
            // console.log('cheking target', name, value)
            let temp = { ...formData }
            temp[name] = value
            setFormData(temp)
    
            // console.log('checking form data', formData)
        }
    
        // register user
        const handleRegisterUsers = async (event) => {
            let contactNo = contact_no_1.concat(contact_no_2);
            formData.contact_no = contactNo;

            console.log('checking form data', formData)
            
            let res = await UserServices.createUsers(formData)
    
            if (res.status === 201) {
                setAlert(true)
                setMessage('User Created Successfully')
                setSeverity('success')
                let id = res?.data?.posted?.res?.id
                console.log('res----------------------->>', res)
                if (formData.type == 'Agent') {
                    if (id != null || id != undefined) {
                        makeStripeAccount(id)
                    }
                } else {
                    setOpen(true)
                    setTimeout(() => {
                        window.location.href = '/session/signin';
                    }, 5000);
                }
                
            } else {
                setAlert(true)
                setMessage('User Created Unsuccessfully')
                setSeverity('error')
            }
        }
   

        const makeStripeAccount = async (id) => {
            
            let params = {
                user_id : id
            }

            let res =  await UserServices.createCustomerStripeAccounts(params)

            if (res.status === 201) {
                setAlert(true)
                setMessage('Stripe Account Created Successfully')
                setSeverity('success')
                // setOpen(true)
                // setTimeout(() => {
                //     window.location.href = '/session/signin';
                // }, 5000);
                let postedData = res.data.posted.res
                setStripeData(postedData)
                setStripeOpen(true)
            } else {
                setAlert(true)
                setMessage('Stripe Account Created Unsuccessfully')
                setSeverity('error') 
            }
        }
        // --------------------------------stepper func ------------------

    const isStepOptional = (step) => {

        return step === 1;
    };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = async () => {
  const isValid = await formRef.current.isFormValid();
  if (!isValid) {
    // 👇 this forces validator to show error messages
    formRef.current.submit();
    return;
  }

  let newSkipped = skipped;
  if (isStepSkipped(activeStep)) {
    newSkipped = new Set(newSkipped.values());
    newSkipped.delete(activeStep);
  }

  setActiveStep((prevActiveStep) => prevActiveStep + 1);
  setSkipped(newSkipped);
};



  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  

  const handleReset = () => {
    setActiveStep(0);
  };

//   -------------------------------

    return (
        <div
            className="flex justify-center items-center min-h-screen"
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundImage: "url('/assets/images/loginBackgraounds/beautiful-girl-doing-yoga1.png')",
                backgroundSize: "cover",
                backgroundPosition: "center",
                padding: "8px",
                minHeight: "100vh", // Ensures full height
                flexDirection: "column", // Keeps content stacked vertically
            }}
        >
            {/* Fix: AppBar should not push content down */}
            <AppBar position="absolute" color="transparent" elevation={0} sx={{ top: 0, width: "100%" }}>
                <Toolbar>
                    <Typography variant="h6" sx={{ flexGrow: 1, textAlign: "center", color: "white", fontSize:'36px' }}>
                        Lyfe Traveller
                    </Typography>
                </Toolbar>
            </AppBar>

            {/* Fix: Added paddingTop to prevent overlap */}
            <Card
             className={classes.responsiveCard}
                
            >

                <Grid container>
                    <Grid item xs={12}>
                        <div className="p-8 h-full flex items-center justify-center">
                            <div className="text-center w-full" style={{ width: "100%" }}>
                                <Typography variant="h5" gutterBottom color="textSecondary" fontWeight="bold">
                                    Sign-Up
                                </Typography>
                                <Typography variant="h6" gutterBottom>
                                    Sign-up for list and manage your property.
                                </Typography>

                                <div className="mt-5"></div>
                                <ValidatorForm onSubmit={handleRegisterUsers} ref={formRef}>
                                    {!stepperOn ?
                                    <Grid container spacing={2}>
                                        {/* First Name | Last Name */}
                                        <Grid item xs={12} md={6}>
                                            <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">First Name</Typography>
                                            <TextValidator
                                                className={classes.fields}
                                                name='first_name'
                                                value={formData.first_name}
                                                placeholder="Type Here"
                                                fullWidth
                                                variant="outlined"
                                                size="medium"
                                                onChange={handleChange}
                                                validators={['required']}
                                                errorMessages={['This field is required']}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">Last Name</Typography>
                                            <TextValidator
                                                className={classes.fields}
                                                name='last_name'
                                                value={formData.last_name}
                                                placeholder="Type Here"
                                                fullWidth
                                                variant="outlined"
                                                size="medium"
                                                onChange={handleChange}
                                                validators={['required']}
                                                errorMessages={['This field is required']}
                                            />
                                        </Grid>

                                        {/* Username | User Type */}
                                        <Grid item xs={12} md={6}>
                                            <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">Username</Typography>
                                            <TextValidator
                                                className={classes.fields}
                                                name='username'
                                                value={formData.username}
                                                placeholder="Type Here"
                                                fullWidth
                                                variant="outlined"
                                                size="medium"
                                                onChange={handleChange}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">User Type</Typography>
                                            <Autocomplete
                                                disableClearable
                                                options={appConst.user_type}
                                                value={appConst.user_type.find((item) => item.label === formData.type)}
                                                onChange={(e, value) => {
                                                    if (value) {
                                                        setFormData({ ...formData, type: value.label });

                                                        if (value.label == 'Agent') {
                                                            setStepperOn(true)
                                                        } else {
                                                            setStepperOn(false)
                                                        }
                                                    }
                                                }}
                                                getOptionLabel={(option) => option.label}
                                                renderInput={(params) => (
                                                    <TextValidator
                                                        {...params}
                                                        className={classes.fields}
                                                        placeholder="Select"
                                                        fullWidth
                                                        value={appConst.user_type.find((item) => item.label === formData.type)?.label}
                                                        variant="outlined"
                                                        size="medium"
                                                        validators={['required']}
                                                        errorMessages={['This field is required']}
                                                    />
                                                )}
                                            />
                                        </Grid>

                                        {/* Email */}
                                        <Grid item xs={12} md={6}>
                                            <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">Email</Typography>
                                            <TextValidator
                                                className={classes.fields}
                                                name='email'
                                                value={formData.email}
                                                placeholder="Type Here"
                                                fullWidth
                                                variant="outlined"
                                                size="medium"
                                                onChange={handleChange}
                                                validators={['required', 'isEmail']}
                                                errorMessages={['This field is required', 'Email is not valid']}
                                                type="email"
                                            />
                                        </Grid>

                                        {/* country */}
                                        
                                        {formData.type == 'Customer' &&
                                        <Grid item xs={12} md={6}>
                                            <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">Country</Typography>
                                            <Autocomplete
                                                disableClearable
                                                options={appConst.currency}
                                                value={appConst.currency.find((item) => item.country === formData.country)}
                                                onChange={(e, value) => {
                                                    if (value) {
                                                        setFormData({ ...formData, country: value.country });
                                                        seContact1(value.dial_code)
                                                    }
                                                }}
                                                getOptionLabel={(option) => option.country}
                                                renderInput={(params) => (
                                                    <TextValidator
                                                        {...params}
                                                        className={classes.fields}
                                                        placeholder="Select"
                                                        fullWidth
                                                        value={appConst.currency.find((item) => item.country === formData.country)?.country}
                                                        variant="outlined"
                                                        size="medium"
                                                        validators={['required']}
                                                        errorMessages={['This field is required']}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    }
                                        {console.log('checking contact no 1', appConst.currency.find((item) => item.dial_code === contact_no_1)?.dial_code)}
                                        <Grid item xs={12} md={6}>
                                            <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">Mobile Number</Typography>
                                            <Grid container spacing={1}>
                                                <Grid item xs={4}>
                                                    <Autocomplete
                                                        name='contact_no_1'
                                                        disableClearable
                                                        options={appConst.currency}
                                                        autoComplete="contact_no_1"
                                                        value={appConst.currency.find((item) => item.dial_code === contact_no_1)}
                                                        onChange={(e, value) => {
                                                            if (value) seContact1(value.dial_code);
                                                        }}
                                                        getOptionLabel={(option) => option.dial_code}
                                                        renderInput={(params) => (
                                                            <TextValidator
                                                                {...params}
                                                                className={classes.fields}
                                                                placeholder="+94"
                                                                value={appConst.currency.find((item) => item.dial_code === contact_no_1)?.dial_code}
                                                                fullWidth
                                                                variant="outlined"
                                                                size="medium"
                                                                validators={['required']}
                                                                errorMessages={['Required']}
                                                            />
                                                        )}
                                                    />
                                                </Grid>
                                                <Grid item xs={8}>
                                                    <TextValidator
                                                        className={classes.fields}
                                                        name='contact_no_2'
                                                        value={contact_no_2}
                                                        fullWidth
                                                        placeholder="Type Here"
                                                        variant="outlined"
                                                        size="medium"
                                                        type="number"
                                                        validators={['required']}
                                                        errorMessages={['This field is required']}
                                                        onChange={(e) => {
                                                            seContact2(e.target.value || null);
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>



                                        {/* Password | Confirm Password */}
                                        <Grid item xs={12} md={6}>
                                            <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">Password</Typography>
                                            <TextValidator
                                                name='password'
                                                className={classes.fields}
                                                value={formData.password}
                                                placeholder="Type Here"
                                                fullWidth
                                                variant="outlined"
                                                size="medium"
                                                onChange={handleChange}
                                                validators={['required']}
                                                errorMessages={['This field is required']}
                                                type={showPassword ? 'text' : 'password'}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                onClick={handleClickShowPassword}
                                                                onMouseDown={handleMouseDownPassword}
                                                                size='small'
                                                            >
                                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">Confirm Password</Typography>
                                            <TextValidator
                                                className={classes.fields}
                                                name='password_conforation'
                                                value={formData.password_conforation}
                                                placeholder="Type Here"
                                                fullWidth
                                                variant="outlined"
                                                size="medium"
                                                onChange={handleChange}
                                                validators={['required', 'isPasswordMatch']}
                                                errorMessages={['This field is required', 'Passwords do not match']}
                                                type="password"
                                            />
                                        </Grid>
                                        {/* Register Button */}
                                        <Grid item xs={12}>
                                            <Button
                                                fullWidth
                                                type="submit"
                                                className="rounded mt-3"
                                                variant="contained"
                                                style={{ backgroundColor: "#24AB70" }}
                                            >
                                                Register
                                            </Button>
                                            <Typography variant="body2" sx={{ mt: 2, textAlign: 'left' }}>
                                                Already have an account?{' '}
                                                <a href="/session/signin" style={{ color: "#1976d2" }}>Log in</a>
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    :
                                        <Box sx={{ width: '100%' }}>
                                            <Stepper activeStep={activeStep} className='mb-3'>
                                                {steps.map((label, index) => {
                                                    const stepProps = {};
                                                    const labelProps = {};
                                                    // if (isStepOptional(index)) {
                                                    //     labelProps.optional = (
                                                    //         <Typography variant="caption">Optional</Typography>
                                                    //     );
                                                    // }
                                                    if (isStepSkipped(index)) {
                                                        stepProps.completed = false;
                                                    }
                                                    return (
                                                        <Step key={label} {...stepProps}>
                                                            <StepLabel {...labelProps}>{label}</StepLabel>
                                                        </Step>
                                                    );
                                                })}
                                            </Stepper>

                                            <React.Fragment>
                                                <Box sx={{ mt: 2, mb: 1 }}>
                                                    {activeStep === 0 && (
                                                        <Grid container spacing={2}>
                                                            {/* First Name | Last Name */}
                                                            <Grid item xs={12} md={6}>
                                                                <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">First Name</Typography>
                                                                <TextValidator
                                                                    className={classes.fields}
                                                                    name='first_name'
                                                                    value={formData.first_name}
                                                                    placeholder="Type Here"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    size="medium"
                                                                    onChange={handleChange}
                                                                    validators={['required']}
                                                                    errorMessages={['This field is required']}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6}>
                                                                <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">Last Name</Typography>
                                                                <TextValidator
                                                                    className={classes.fields}
                                                                    name='last_name'
                                                                    value={formData.last_name}
                                                                    placeholder="Type Here"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    size="medium"
                                                                    onChange={handleChange}
                                                                    validators={['required']}
                                                                    errorMessages={['This field is required']}
                                                                />
                                                            </Grid>

                                                            {/* Username | User Type */}
                                                            <Grid item xs={12} md={6}>
                                                                <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">Username</Typography>
                                                                <TextValidator
                                                                    className={classes.fields}
                                                                    name='username'
                                                                    value={formData.username}
                                                                    placeholder="Type Here"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    size="medium"
                                                                    onChange={handleChange}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6}>
                                                                <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">User Type</Typography>
                                                                <Autocomplete
                                                                    disableClearable
                                                                    options={appConst.user_type}
                                                                    value={appConst.user_type.find((item) => item.label === formData.type)}
                                                                    onChange={(e, value) => {
                                                                        if (value) {
                                                                            setFormData({ ...formData, type: value.label });

                                                                            if (value.label == 'Agent') {
                                                                                setStepperOn(true)
                                                                            } else {
                                                                                setStepperOn(false)
                                                                            }
                                                                        }
                                                                    }}
                                                                    getOptionLabel={(option) => option.label}
                                                                    renderInput={(params) => (
                                                                        <TextValidator
                                                                            {...params}
                                                                            className={classes.fields}
                                                                            placeholder="Select"
                                                                            fullWidth
                                                                            value={appConst.user_type.find((item) => item.label === formData.type)?.label}
                                                                            variant="outlined"
                                                                            size="medium"
                                                                            validators={['required']}
                                                                            errorMessages={['This field is required']}
                                                                        />
                                                                    )}
                                                                />
                                                            </Grid>

                                                            {/* Email */}
                                                            <Grid item xs={12} md={6}>
                                                                <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">Email</Typography>
                                                                <TextValidator
                                                                    className={classes.fields}
                                                                    name='email'
                                                                    value={formData.email}
                                                                    placeholder="Type Here"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    size="medium"
                                                                    onChange={handleChange}
                                                                    validators={['required', 'isEmail']}
                                                                    errorMessages={['This field is required', 'Email is not valid']}
                                                                    type="email"
                                                                />
                                                            </Grid>

                                                            {/* country */}
                                                            
                                                            {formData.type == 'Agent' &&
                                                            <Grid item xs={12} md={6}>
                                                                <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">Country</Typography>
                                                                <Autocomplete
                                                                    disableClearable
                                                                    options={appConst.currency}
                                                                    value={appConst.currency.find((item) => item.country === formData.country)}
                                                                    onChange={(e, value) => {
                                                                        if (value) {
                                                                            setFormData({ ...formData, country: value.country });
                                                                            seContact1(value.dial_code)
                                                                        }
                                                                    }}
                                                                    getOptionLabel={(option) => option.country}
                                                                    renderInput={(params) => (
                                                                        <TextValidator
                                                                            {...params}
                                                                            className={classes.fields}
                                                                            placeholder="Select"
                                                                            fullWidth
                                                                            value={appConst.currency.find((item) => item.country === formData.country)?.country}
                                                                            variant="outlined"
                                                                            size="medium"
                                                                            validators={['required']}
                                                                            errorMessages={['This field is required']}
                                                                        />
                                                                    )}
                                                                />
                                                            </Grid>
                                                        }
                                                            {console.log('checking contact no 1', appConst.currency.find((item) => item.dial_code === contact_no_1)?.dial_code)}
                                                            <Grid item xs={12} md={6}>
                                                                <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">Mobile Number</Typography>
                                                                <Grid container spacing={1}>
                                                                    <Grid item xs={4}>
                                                                        <Autocomplete
                                                                            name='contact_no_1'
                                                                            disableClearable
                                                                            options={appConst.currency}
                                                                            autoComplete="contact_no_1"
                                                                            value={appConst.currency.find((item) => item.dial_code === contact_no_1)}
                                                                            onChange={(e, value) => {
                                                                                if (value) seContact1(value.dial_code);
                                                                            }}
                                                                            getOptionLabel={(option) => option.dial_code}
                                                                            renderInput={(params) => (
                                                                                <TextValidator
                                                                                    {...params}
                                                                                    className={classes.fields}
                                                                                    placeholder="+94"
                                                                                    value={appConst.currency.find((item) => item.dial_code === contact_no_1)?.dial_code}
                                                                                    fullWidth
                                                                                    variant="outlined"
                                                                                    size="medium"
                                                                                    validators={['required']}
                                                                                    errorMessages={['Required']}
                                                                                />
                                                                            )}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={8}>
                                                                        <TextValidator
                                                                            className={classes.fields}
                                                                            name='contact_no_2'
                                                                            value={contact_no_2}
                                                                            fullWidth
                                                                            placeholder="Type Here"
                                                                            variant="outlined"
                                                                            size="medium"
                                                                            type="number"
                                                                            validators={['required']}
                                                                            errorMessages={['This field is required']}
                                                                            onChange={(e) => {
                                                                                seContact2(e.target.value || null);
                                                                            }}
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>



                                                            {/* Password | Confirm Password */}
                                                            <Grid item xs={12} md={6}>
                                                                <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">Password</Typography>
                                                                <TextValidator
                                                                    name='password'
                                                                    className={classes.fields}
                                                                    value={formData.password}
                                                                    placeholder="Type Here"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    size="medium"
                                                                    onChange={handleChange}
                                                                    validators={['required']}
                                                                    errorMessages={['This field is required']}
                                                                    type={showPassword ? 'text' : 'password'}
                                                                    InputProps={{
                                                                        endAdornment: (
                                                                            <InputAdornment position="end">
                                                                                <IconButton
                                                                                    onClick={handleClickShowPassword}
                                                                                    onMouseDown={handleMouseDownPassword}
                                                                                    size='small'
                                                                                >
                                                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                                                </IconButton>
                                                                            </InputAdornment>
                                                                        ),
                                                                    }}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6}>
                                                                <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">Confirm Password</Typography>
                                                                <TextValidator
                                                                    className={classes.fields}
                                                                    name='password_conforation'
                                                                    value={formData.password_conforation}
                                                                    placeholder="Type Here"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    size="medium"
                                                                    onChange={handleChange}
                                                                    validators={['required', 'isPasswordMatch']}
                                                                    errorMessages={['This field is required', 'Passwords do not match']}
                                                                    type="password"
                                                                />
                                                            </Grid>
                                                            {/* Register Button */}
                                                            
                                                        </Grid>
                                                    )}

                                                    {activeStep === 1 && (
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12} md={6}>
                                                                <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">NIC</Typography>
                                                                <TextValidator
                                                                    className={classes.fields}
                                                                    name='nic'
                                                                    value={formData.nic || ''}
                                                                    placeholder="Type Here"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    size="medium"
                                                                    onChange={handleChange}
                                                                    validators={['required']}
                                                                    errorMessages={['This field is required']}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} md={6}>
                                                                <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">Passport No</Typography>
                                                                <TextValidator
                                                                    className={classes.fields}
                                                                    name='passport_no'
                                                                    value={formData.passport_no || ''}
                                                                    placeholder="Type Here"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    size="medium"
                                                                    onChange={handleChange}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} md={6}>
                                                                <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">Agency Name</Typography>
                                                                <TextValidator
                                                                    className={classes.fields}
                                                                    name='agency_name'
                                                                    value={formData.agency_name || ''}
                                                                    placeholder="Type Here"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    size="medium"
                                                                    onChange={handleChange}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} md={6}>
                                                                <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">Agency Type</Typography>
                                                                <TextValidator
                                                                    className={classes.fields}
                                                                    name='agency_type'
                                                                    value={formData.agency_type || ''}
                                                                    placeholder="Type Here"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    size="medium"
                                                                    onChange={handleChange}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} md={6}>
                                                                <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">Registration No</Typography>
                                                                <TextValidator
                                                                    className={classes.fields}
                                                                    name='registration_no'
                                                                    value={formData.registration_no || ''}
                                                                    placeholder="Type Here"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    size="medium"
                                                                    onChange={handleChange}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} md={6}>
                                                                <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">Website</Typography>
                                                                <TextValidator
                                                                    className={classes.fields}
                                                                    name='website'
                                                                    value={formData.website || ''}
                                                                    placeholder="Type Here"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    size="medium"
                                                                    onChange={handleChange}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} md={6}>
                                                                <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">Business No</Typography>
                                                                <TextValidator
                                                                    className={classes.fields}
                                                                    name='business_no'
                                                                    value={formData.business_no || ''}
                                                                    placeholder="Type Here"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    size="medium"
                                                                    onChange={handleChange}
                                                                />
                                                            </Grid>

                                                            {/* <Grid item xs={12} md={6}>
                                                                <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">Commission (%)</Typography>
                                                                <TextValidator
                                                                    className={classes.fields}
                                                                    name='commision'
                                                                    value={formData.commision || ''}
                                                                    placeholder="Type Here"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    size="medium"
                                                                    type="number"
                                                                    onChange={handleChange}
                                                                    validators={['required']}
                                                                    errorMessages={['This field is required']}
                                                                />
                                                            </Grid> */}

                                                            
                                                        </Grid>
                                                    )}

                                                    {activeStep === 2 && (
                                                        <Grid container spacing={2}>

                                                            <Grid item xs={12} md={6}>
                                                                <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">Address Line 1</Typography>
                                                                <TextValidator
                                                                    className={classes.fields}
                                                                    name='address_line_1'
                                                                    value={formData.address_line_1 || ''}
                                                                    placeholder="Type Here"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    size="medium"
                                                                    onChange={handleChange}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} md={6}>
                                                                <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">Address Line 2</Typography>
                                                                <TextValidator
                                                                    className={classes.fields}
                                                                    name='address_line_2'
                                                                    value={formData.address_line_2 || ''}
                                                                    placeholder="Type Here"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    size="medium"
                                                                    onChange={handleChange}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} md={6}>
                                                                <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">City</Typography>
                                                                <TextValidator
                                                                    className={classes.fields}
                                                                    name='city'
                                                                    value={formData.city || ''}
                                                                    placeholder="Type Here"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    size="medium"
                                                                    onChange={handleChange}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} md={6}>
                                                                <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">Zip Code</Typography>
                                                                <TextValidator
                                                                    className={classes.fields}
                                                                    name='zip_code'
                                                                    value={formData.zip_code || ''}
                                                                    placeholder="Type Here"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    size="medium"
                                                                    onChange={handleChange}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} md={6}>
                                                                <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">State</Typography>
                                                                <TextValidator
                                                                    className={classes.fields}
                                                                    name='state'
                                                                    value={formData.state || ''}
                                                                    placeholder="Type Here"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    size="medium"
                                                                    onChange={handleChange}
                                                                />
                                                            </Grid>

                                                            

                                                            <Grid item xs={12}>
                                                                <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">Hobbies & Interests</Typography>
                                                                <TextValidator
                                                                    className={classes.fields}
                                                                    name='hobbies_and_interest'
                                                                    value={formData.hobbies_and_interest || ''}
                                                                    placeholder="Type Here"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    size="medium"
                                                                    onChange={handleChange}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">Current Profession</Typography>
                                                                <TextValidator
                                                                    className={classes.fields}
                                                                    name='current_profession'
                                                                    value={formData.current_profession || ''}
                                                                    placeholder="Type Here"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    size="medium"
                                                                    onChange={handleChange}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                <Typography className='text-15' sx={{ lineHeight: 1, textAlign: "left" }} variant="subtitle1">Other Remarks</Typography>
                                                                <TextValidator
                                                                    className={classes.fields}
                                                                    name='other_remarks'
                                                                    value={formData.other_remarks || ''}
                                                                    placeholder="Type Here"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    size="medium"
                                                                    onChange={handleChange}
                                                                />
                                                            </Grid>

                                                            

                                                            <Grid item xs={12}>
                                                                <Button
                                                                    fullWidth
                                                                    type="submit"
                                                                    className="rounded mt-3"
                                                                    variant="contained"
                                                                    style={{ backgroundColor: "#24AB70" }}
                                                                >
                                                                    Register
                                                                </Button>
                                                                <Typography variant="body2" sx={{ mt: 2, textAlign: 'left' }}>
                                                                    Already have an account?{' '}
                                                                    <a href="/session/signin" style={{ color: "#1976d2" }}>Log in</a>
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    )}
                                                </Box>

                                                {/* Stepper Navigation */}
                                                <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                                                    <Button
                                                        // color="inherit"
                                                        disabled={activeStep === 0}
                                                        onClick={handleBack}
                                                        sx={{ mr: 1 }}
                                                        color='primary'
                                                        variant='outlined'
                                                    >
                                                        Back
                                                    </Button>
                                                    <Box sx={{ flex: '1 1 auto' }} />
                                                    {/* {isStepOptional(activeStep) && (
                                                        <Button color="inherit" onClick={handleSkip} sx={{ mr: 1 }}>
                                                            Skip
                                                        </Button>
                                                    )} */}
                                                    <Button 
                                                        onClick={handleNext} 
                                                        disabled={activeStep === 2}
                                                        color='primary'
                                                        variant='outlined'
                                                    >
                                                        Next
                                                    </Button>
                                                </Box>
                                            </React.Fragment>
                                        </Box>
                                    }
                                    
                                </ValidatorForm>

                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Card>

            <Dialog
                open={open}
                maxWidth="sm"
                fullWidth
                style={{paddingTop: "20px", 
                        paddingBottom: "20px"}}
                PaperProps={{
                    sx: { borderRadius: "16px", textAlign: "center", p: 4,  }
                }}
                >
                <DialogContent sx={{ textAlign: "center", paddingTop: "10px", 
                        paddingBottom: "10px", marginTop:'10px' }}>
                    {/* Circle with dots */}
                    <Box
                        sx={{
                        width: 90,
                        height: 90,
                        borderRadius: "50%",
                        backgroundColor: "#4a6741",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto",
                        mb: 3,
                        border: "10px solid #ccc6c6",
                        marginTop: "10px", 
                        marginBottom: "10px"
                        }}
                    >
                        <Typography variant="h5" sx={{ color: "white" }}>
                        ...
                        </Typography>
                    </Box>
                    
                    {/* Main Message */}
                    <div className='mt-10 mb-10'>
                    <Typography align="center" variant="subtitle1" sx={{ fontWeight: 600, mb: 2, color: "#576F4F"}}>
                    We've sent you an email verification <br /> to confirm your account.
                    </Typography>
                    </div>
                    <div className='mt-10 mb-10'>
                    <Typography align="center" variant="body2" color="text.secondary">
                    Please check your inbox and follow the instructions to complete the process
                    </Typography>
                    </div>

                    </DialogContent>

                </Dialog>

                <Dialog
                    open={stripeOpen}
                    // onClose={()=>{setStripeOpen(false)}}
                    maxWidth="sm"
                    fullWidth
                    PaperProps={{
                        sx: { borderRadius: "20px", textAlign: "center", p: 3 }
                    }}
                    >
                    {/* <IconButton
                        onClick={()=>{setStripeOpen(false)}}
                        sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        background: "#fff",
                        "&:hover": { background: "#f0f0f0" }
                        }}
                    >
                        <CloseIcon />
                    </IconButton> */}

                    <DialogTitle sx={{ pt: 4 }}>
                        
                        <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                            spacing={3}
                            sx={{ textAlign: "center" }}
                            className='flex justify-center items-center'
                        >
                            <Grid item  xs={12}>
                                <CheckCircleOutlineIcon sx={{ fontSize: 60, color: "green" }} />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="h5" fontWeight="bold" mt={2}>
                                    Stripe Account Created Successfully!
                                </Typography>
                            </Grid>
                        </Grid>
                        
                    </DialogTitle>

                    <DialogContent>
                        <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                            spacing={2}
                            sx={{ textAlign: "center", height:'100%' }}
                            
                        >
                            <Grid item>
                            <Typography variant="body1">
                                Your Stripe Account ID: <b>{stripeData?.stripeAccountId}</b>
                            </Typography>
                            </Grid>
                            <Grid item>
                            <Button
                                variant="contained"
                                color="primary"
                                href={stripeData?.onboarding_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                borderRadius: "25px",
                                px: 4,
                                py: 1.5,
                                fontSize: "1rem",
                                textTransform: "none",
                                boxShadow: 3,
                                marginBottom:'20px'
                                }}
                            >
                                Finish Setup on Stripe
                            </Button>
                            </Grid>
                        </Grid>
                        </DialogContent>

                    </Dialog>

            <LoonsSnackbar
                open={alert}
                onClose={() => setAlert(false)} 
                message={message}
                autoHideDuration={3000}
                severity={severity}
                elevation={2}
                variant="filled"
            ></LoonsSnackbar>
        </div>

    )
}

export default FirebaseRegister
